module.exports = __webpack_public_path__ + "static/media/giftcard-babyshower.6df71506.jpg";